import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=587f2762"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587f2762')) {
      api.createRecord('587f2762', component.options)
    } else {
      api.reload('587f2762', component.options)
    }
    module.hot.accept("./Tables.vue?vue&type=template&id=587f2762", function () {
      api.rerender('587f2762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/template/components/Tables.vue"
export default component.exports